/**
 * Fire a write, then persist the drawer's drafted claim a tick later.
 *
 * Both stock hand-offs — "Create delivery" and "Add to order" — have to save
 * the draft the delivery points at, or the order would name a claim that was
 * never stored. The order is deliberate: the draft save dispatches to the
 * store and re-renders the whole scheduler (measured ~450 ms on a real plan),
 * so running it synchronously on the click would sit between the click and
 * anything visible happening — the request, and the button's pending state.
 * Deferred by a macrotask, the request is already in flight and the button has
 * flipped before the save runs, and it still lands well before the response.
 */
export function fireThenPersist(fire: () => void, persist: () => void): void {
  fire();
  setTimeout(persist, 0);
}
